export default __webpack_public_path__ + "static/media/img5.b22df3d9.png";